/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Bed } from './Bed';
import {
    BedFromJSON,
    BedFromJSONTyped,
    BedToJSON,
    BedToJSONTyped,
} from './Bed';

/**
 * 
 * @export
 * @interface BulkUpdateBedsRequest
 */
export interface BulkUpdateBedsRequest {
    /**
     * 
     */
    beds: Array<Bed>;
}

/**
 * Check if a given object implements the BulkUpdateBedsRequest interface.
 */
export function instanceOfBulkUpdateBedsRequest(value: object): value is BulkUpdateBedsRequest {
    if (!('beds' in value) || value['beds'] === undefined) return false;
    return true;
}

export function BulkUpdateBedsRequestFromJSON(json: any): BulkUpdateBedsRequest {
    return BulkUpdateBedsRequestFromJSONTyped(json, false);
}

export function BulkUpdateBedsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateBedsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'beds': ((json['beds'] as Array<any>).map(BedFromJSON)),
    };
}

export function BulkUpdateBedsRequestToJSON(json: any): BulkUpdateBedsRequest {
    return BulkUpdateBedsRequestToJSONTyped(json, false);
}

export function BulkUpdateBedsRequestToJSONTyped(value?: BulkUpdateBedsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'beds': ((value['beds'] as Array<any>).map(BedToJSON)),
    };
}

